// Port de app/(tabs)/abono.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const SolicitacaoAbonoScreen = lazy(() => import("@/screens/SolicitacaoAbono"));

export default function AbonoRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <SolicitacaoAbonoScreen />
    </Carregando>
  ) : null;
}
